import './Overlay-a7e4194c.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl","overlay-appear":"prc-Overlay-overlay-appear-DGY3B"};

export { classes as default };
